import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react'; // Added ChevronDown

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // We keep this for Mobile Menu mainly
  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    // Services is handled manually in desktop, but kept here for mobile list
    { path: '/services', label: 'Services' },
    { path: '/projects', label: 'Projects' },
    { path: '/blog', label: 'Blog' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          
          {/* Logo Section */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="/logo.png" 
              alt="Logo" 
              className="transition-transform duration-300 group-hover:scale-110"
              style={{height:"100px"}} 
            />
            <div>
              <span className="font-heading text-xl font-bold text-[#1E5631] block">
                Udyaan Landscaping
              </span>
              <span className="text-xs text-gray-600">Professional Horticulture Services</span>
            </div>
          </Link>

          {/* Desktop Navigation - UPDATED WITH DROPDOWN */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="font-heading text-gray-700 hover:text-[#1E5631] font-medium">Home</Link>
            <Link to="/about" className="font-heading text-gray-700 hover:text-[#1E5631] font-medium">About</Link>
            
            {/* NEW SERVICES DROPDOWN */}
            <div className="relative group">
              <button className="flex items-center font-heading text-gray-700 group-hover:text-[#1E5631] font-medium py-2">
                Services
                <ChevronDown className="ml-1 w-4 h-4" />
              </button>
              
              {/* The Dropdown Menu Box */}
              <div className="absolute top-full left-0 w-64 bg-white shadow-xl rounded-lg py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 border-t-4 border-[#4CAF50]">
                <Link to="/services?cat=mining" className="block px-4 py-3 hover:bg-gray-50 text-sm text-gray-700 hover:text-[#1E5631]">
                  Miyawaki & Mine Reclamation
                </Link>
                <Link to="/services?cat=residential" className="block px-4 py-3 hover:bg-gray-50 text-sm text-gray-700 hover:text-[#1E5631]">
                  Residential Landscaping
                </Link>
                <Link to="/services?cat=wholesale" className="block px-4 py-3 hover:bg-gray-50 text-sm text-gray-700 hover:text-[#1E5631]">
                  Wholesale Plant Nursery
                </Link>
              </div>
            </div>

            <Link to="/projects" className="font-heading text-gray-700 hover:text-[#1E5631] font-medium">Projects</Link>
            
            <Link
              to="/contact"
              className="btn-primary px-6 py-2 rounded-lg"
            >
              Get Free Consultation
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-md hover:bg-gray-100 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-[#1E5631]" />
            ) : (
              <Menu className="w-6 h-6 text-[#1E5631]" />
            )}
          </button>
        </div>

        {/* Mobile Menu Content */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200 animate-fade-in">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`text-base font-medium px-4 py-2 rounded-md transition-colors font-heading ${
                    location.pathname === link.path
                      ? 'bg-[#1E5631] text-white'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="btn-primary mx-4 text-center"
              >
                Get Free Consultation
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};